<template>
  <div class="flex flex-row justify-end">
    <v-btn class="ma-2" color="primary" @click="moveSlideUp" :disabled="index <= 0">
      <v-icon left>mdi-arrow-up</v-icon>
      Move Up
    </v-btn>
    <v-btn
      class="ma-2"
      color="primary"
      @click="moveSlideDown"
      :disabled="index >= array.length - 1"
    >
      <v-icon left>mdi-arrow-down</v-icon>
      Move Down
    </v-btn>
  </div>
</template>

<script>
export default {
  name: 'XSArrayItemNavigator',
  props: {
    array: {
      type: Array,
      required: true,
    },
    index: {
      type: Number,
      required: true,
    },
    moveSlideUp: {
      type: Function,
      required: true,
    },
    moveSlideDown: {
      type: Function,
      required: true,
    },
  },
};
</script>
